import { type ReactNode } from 'react';
import clsx from 'clsx';
import { Tooltip } from '@hungryroot/pho';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './PlanSection.module.css';

interface Props {
  testid?: string;
  title: string;
  children: ReactNode;
  description?: string | null;
  tooltip?: ReactNode;
  titleClassName?: string;
  containerClassName?: string;
  showSubsections?: boolean;
}

export function PlanSection(props: Props) {
  const {
    testid,
    title,
    children,
    description,
    tooltip,
    containerClassName,
    titleClassName,
    showSubsections,
  } = props;
  return (
    <div data-testid={testid} className={containerClassName}>
      {showSubsections && (
        <>
          <div className={styles['title-container']}>
            <div className={`${styles.title} ${titleClassName}`}>
              <Heading variant="H4">{title}</Heading>
              {tooltip && (
                <div className={styles['tooltip-container']}>
                  <Tooltip
                    className={styles['tooltip-bubble']}
                    testid={`${testid}-tooltip`}
                    containerClassName={styles.tooltip}
                    content={tooltip}
                  />
                </div>
              )}
            </div>
          </div>
          {description && (
            <Paragraph className={styles.description}>{description}</Paragraph>
          )}
        </>
      )}
      <div
        className={clsx({
          [styles.children]: showSubsections,
        })}
      >
        {children}
      </div>
    </div>
  );
}
